import classNames from 'classnames';
import { Control, Field, Help, Label } from 'rbx';
import * as React from 'react';

interface IProps {
    children?: React.ReactNode;
    type?: any;
    label?: string;
    help?: string;
    placeholder?: string;
    value?: string;
    inputColor?: any;
    readOnly?: boolean;
    disabled?: boolean;
    horizontal?: boolean;
    cy?: string;
    onChange?: (e: any) => void;
    onKeyDown?: (e: React.SyntheticEvent<HTMLInputElement>) => void;
}

export default class FormField extends React.Component<IProps, {}> {
    private updateContent = (event: React.ChangeEvent<HTMLInputElement>): void => {
        if (typeof this.props.onChange === 'function') {
            this.props.onChange(event.target.value);
        }
    };

    public render() {
        const {
            value,
            type,
            label,
            help,
            placeholder,
            readOnly,
            disabled,
            horizontal,
            inputColor,
            onKeyDown,
            cy,
        } = this.props;

        return (
            <>
                {horizontal === true ? (
                    <Field horizontal={horizontal}>
                        {label && (
                            <div className="field-label is-normal">
                                <Label>{label}</Label>
                            </div>
                        )}
                        <Field.Body>
                            <Field>
                                <Control expanded={true} data-cy={cy}>
                                    <input
                                        value={value || ''}
                                        onChange={this.updateContent}
                                        onKeyDown={onKeyDown as any}
                                        type={type ? type : 'text'}
                                        className={classNames('input', { [`is-${inputColor}`]: inputColor })}
                                        placeholder={placeholder}
                                        readOnly={readOnly}
                                        disabled={disabled}
                                        style={disabled ? { opacity: 1, color: '#363636', backgroundColor: '#ebf1f5', borderColor: '#d6e2ea' } : undefined}
                                    />
                                </Control>
                            </Field>
                        </Field.Body>

                        {help && <Help>{help}</Help>}
                    </Field>
                ) : (
                    <Field>
                        {label && <Label>{label}</Label>}
                        <Control expanded={true} data-cy={cy}>
                            <input
                                value={value || ''}
                                onChange={this.updateContent}
                                onKeyDown={onKeyDown as any}
                                className={classNames('input', { [`is-${inputColor}`]: inputColor })}
                                type={type ? type : 'text'}
                                placeholder={placeholder}
                                readOnly={readOnly}
                                disabled={disabled}
                                style={disabled ? { opacity: 1, color: '#363636', backgroundColor: '#ebf1f5', borderColor: '#d6e2ea' } : undefined}
                            />
                        </Control>
                        {help && <Help>{help}</Help>}
                    </Field>
                )}
            </>
        );
    }
}
